var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.9898 9C18.4398 9 17.9898 9.45 17.9898 10C17.9898 14.4 14.4098 17.99 9.99977 17.99C5.58977 17.99 2.00977 14.41 2.00977 10C2.00977 5.59 5.58977 2.01001 9.99977 2.01001C10.5498 2.01001 10.9998 1.56001 10.9998 1.01001C10.9998 0.46001 10.5498 0.0100098 9.99977 0.0100098C4.48977 0.0100098 0.00976562 4.49 0.00976562 10C0.00976562 15.51 4.48977 19.99 9.99977 19.99C15.5098 19.99 19.9898 15.51 19.9898 10C19.9898 9.45 19.5398 9 18.9898 9Z",
    fill: "#00B347"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.70978 8.29993C6.31978 7.90993 5.68978 7.90993 5.29978 8.29993C4.90978 8.68993 4.90978 9.31996 5.29978 9.70996L8.55977 12.96C8.91977 13.32 9.40977 13.5299 9.91977 13.5299C9.95977 13.5299 9.99977 13.5299 10.0398 13.5299C10.5898 13.4999 11.0998 13.2299 11.4398 12.7899L17.7898 4.62C18.1298 4.18 18.0498 3.55997 17.6198 3.21997C17.1798 2.87997 16.5598 2.96002 16.2198 3.39002L9.91977 11.5L6.71978 8.29993H6.70978Z",
    fill: "#00B347"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogin);
export default __webpack_public_path__ + "static/media/login.5da18f5c6d168a44d5058126e86d8bec.svg";
export { ForwardRef as ReactComponent };